import { ArchiveCheckOutlineIcon } from './ArchiveCheckOutlineIcon';

/**
 * author: Colton Wiscombe
 * id F5A70DE2-BC31-4FCA-AE8E-5295D2F5DB7B
 * name archive-check-outline
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/archive-check-outline.svg
 * tags
 */
export const BoxCheckOutlineIcon = ArchiveCheckOutlineIcon;
export default BoxCheckOutlineIcon